// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"89":"component---src-templates-page-js","834":"94726e6d"}[chunkId] || chunkId) + "-" + {"89":"ef0b015e9ed63ce38c73","108":"0337c52b37da86ba0074","452":"0dfba6ad7d5df9d58ef1","834":"e8d63127fed7c5915c65"}[chunkId] + ".js";
};